export default {
  title: 'Try Kegel plan for a week',
  text_1: 'Money shouldn\'t stand in the way of finding a plan that finally works.',
  text_2: '<b>It costs us approximately $9.73 to offer a 7-day trial.</b> Please pick an amount that\'s reasonable for you.',
  choose_title: 'Choose a price for your 7-day trial:',
  help_text: 'This option will help us support those who need to select the lowest trial prices!',
  button: 'Continue'
}
